import React from "react";
import { TypographyText } from "./style";

export default function Text({ children }) {
  return <TypographyText>{children}</TypographyText>;
}
